<template>
  <div>
    <Toggle :value="value" falseIcon="unlock" trueIcon="lock" v-on="$listeners">
      <template slot="trueDescription">
        <slot name="restrict">Restrict {{label}}</slot>
      </template>
      <template slot="falseDescription">
        <slot name="allow">Allow {{label}}</slot>
      </template>
    </Toggle>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
export default {
  props: {value: Boolean, label: String},
  computed: {
      ...mapGetters(['user', 'isAdmin'])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/RestrictedToggle.vue